import { createSelector } from '@reduxjs/toolkit';
import { selectFacilitiesValue } from './selectFacilitiesValue';
import { EFacilityType } from '../../../../packages/JsonQuery';

const OPTIONS = [
  { label: 'Кондиционер', value: EFacilityType.Conditioner },
  { label: 'Без мебели', value: EFacilityType.WithoutFurniture },
  { label: 'Интернет', value: EFacilityType.Internet },
  { label: 'Холодильник', value: EFacilityType.Fridge },
  { label: 'Комнатная мебель', value: EFacilityType.RoomFurniture },
  { label: 'Телефон', value: EFacilityType.Phone },
  { label: 'Посудомоечная машина', value: EFacilityType.Dishwasher },
  { label: 'Кухонная мебель', value: EFacilityType.KitchenFurniture },
  { label: 'Телевизор', value: EFacilityType.TV },
  { label: 'Стиральная машина', value: EFacilityType.Washer },
];

export const selectFacilitiesFilter = createSelector(selectFacilitiesValue, value => ({
  label: 'Удобства',
  value,
  options: OPTIONS,
}));
